// Размер контейнера с иллюстрацией на волне
export const BOX_SIZE = 200
